import _ from 'lodash';

// import locale for moment.js
import 'moment/locale/fr';

import en from '../locales/build/en.json';
import fr from '../locales/build/fr.json';

const builtLanguages = { en, fr };
const developmentLanguages = {};

if (import.meta.env.DEV) {
  const devEnModule = await import('./devEn');
  const devEn = devEnModule.default;

  const enModule = await import('./en.json');
  const legacyJson = enModule.default;

  developmentLanguages.en = {
    ...legacyJson,
    ...flattenMessages(devEn)
  };
}

function flatten(data) {
  var result = {};
  function recurse(cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else {
      var isEmpty = true;
      //eslint-disable-next-line
      for (var p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop + '.' + p : p);
      }
      if (isEmpty && prop)
        result[prop] = {};
    }
  }
  recurse(data, '');
  return result;
}

function flattenMessages(localeModules) {
  const flattenedMessagesByModule = localeModules.reduce((accu, m) => ([
    ...accu,
    flatten(m)
  ]), []);

  const messages = {};
  for (const m of flattenedMessagesByModule) {
    _.forOwn(m, (value, key) => {
      if (messages[key]) {
        throw new Error(`Duplicate translation key: ${key}`);
      }
      messages[key] = value;
    });
  }

  return messages;
}

export default(language) => {
  if (_.get(builtLanguages, language)) {
    return developmentLanguages[language] || builtLanguages[language];
  }

  if (language) {
    throw new Error(`Language ${language} is not supported.`);
  } else {
    throw new Error(`language argument is required.`);
  }
};
